// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--1ucMb","img":"img--3z6Qm","text":"text--1zn_3"};